import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { NgxDateRangePickerOutput } from 'ngx-date-range-picker';

export const validOfferRangeOptOut = (minBulkValue: number, maxBulkValue: number, allowZeroValue: boolean): ValidatorFn => {
  return (g: AbstractControl): ValidationErrors | null => {
    const offerValue = g.get('offerValue')?.value ?? null;
    const optOut = g.get('optOut')?.value ?? false;
    const offerLock = g.get('offerLock')?.value ?? false;

    if (optOut) {
      return null;
    }

    const hasValue = offerValue !== null && offerValue !== '';

    if (offerLock && !hasValue) {
      return null;
    }

    if (offerValue === 0 && allowZeroValue) {
      return null;
    }

    if (!hasValue || offerValue < minBulkValue || offerValue > maxBulkValue || offerValue === 0) {
      return { offerValue: 'OFFER_VALUE_LIMIT_RANGE' };
    }

    return null;
  };
};

export const requiredPickerDate = (startEnd: 'Start' | 'End'): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const formControl = control as FormControl<NgxDateRangePickerOutput | null>;
    if (!formControl.value?.start) {
      return { required: `REQUIRED_${startEnd.toUpperCase()}_DATE` };
    }
    return null;
  };
};
